import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Thumbs } from 'swiper';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart as farFaHeart } from '@fortawesome/free-regular-svg-icons';
import { faHeart as fasFaHeart } from '@fortawesome/free-solid-svg-icons';

import { URL } from 'utilities/consts';
import { ButtonView } from 'utilities/components/button/component/view';
import { Modal } from 'utilities/components/modal';
import { Img } from 'utilities/components/img/component';

import coins from 'assets/images/product/coins.svg';
import shareIcon from 'assets/images/share.svg';
import downloadIcon from 'assets/images/product/download--icon.svg';

import './view.scss';
import { ButtonsView } from 'utilities/components/buttons/component/view';
import { useAppDispatch, useAppSelector } from 'utilities/redux/reduxHooks';
import { setFavoriteDoor, setFavoriteAccesory, selectFavorites } from 'utilities/redux/favoritesSlice';
import { paths } from 'utilities/routes';
import { Property } from 'utilities/components/product/property/component';
import { ListView } from 'utilities/components/product/list/component/view';
import { getMainDoorImage } from 'utilities/helpers/getMainDoorImage';

SwiperCore.use([Thumbs]);
const COLOR_VIRIDIAN_GREEN = '#62917b';

export const DetailsView = ({
    product, properties, isVisible, isClient, children, setVisibility
}) => {
    const dispatch = useAppDispatch();
    const favoritesValues = useAppSelector(selectFavorites);
    const [isAccessory, setIsAccessory] = useState(false);
    const [sliderIndex, setSliderIndex] = useState(0);
    const windowWidth = (typeof window) === 'undefined' ? 1920 : window.innerWidth;
    const isDesktop = windowWidth > 1024;
    useEffect(() => {
        if (typeof window !== 'undefined') {
            if (window.location.pathname.includes(paths.akcesorium)) {
                setIsAccessory(true);
            }
        }
    }, []);

    const isFavorite = () => {
        if (product?.alternative_id in favoritesValues?.favoriteDoors && !isAccessory) {
            return true;
        }

        if (product?.alternative_id in favoritesValues?.favoriteAccesories && isAccessory) {
            return true;
        }
        return false;
    };

    const setFavorite = () => {
        if (isAccessory) {
            dispatch(setFavoriteAccesory(product?.alternative_id));
        } else {
            dispatch(setFavoriteDoor(product?.alternative_id));
        }
    };
    const variants = [...(product.variants || []), ...(product.custom_variants || [])];

    const image = `${process.env.GATSBY_URL}/${
        variants?.filter(
            (trimset) => properties?.finish === trimset?.line_variant.name && properties?.color.name === trimset?.color.name
        )[0]?.main_model
        || getMainDoorImage(product)
        || product?.color_gallery?.filter(
            (color) => parseInt(color?.color_id, 10)
                === product?.color_list?.filter((item) => item?.name === properties?.color.name)[0]?.alternative_id
        )[0]?.color_image
        || product?.image
    }`;
    const secondImage = variants?.filter(
        (trimset) => properties?.finish === trimset?.line_variant.name && properties?.color.name === trimset?.color.name
    )[0]?.second_model;
    const thirdImage = variants?.filter(
        (trimset) => properties?.finish === trimset?.line_variant.name && properties?.color.name === trimset?.color.name
    )[0]?.third_model;
    const fourthImage = variants?.filter(
        (trimset) => properties?.finish === trimset?.line_variant.name && properties?.color.name === trimset?.color.name
    )[0]?.fourth_model;
    const fifthImage = variants?.filter(
        (trimset) => properties?.finish === trimset?.line_variant.name && properties?.color.name === trimset?.color.name
    )[0]?.fifth_model;
    const [images, setImages] = useState([image]);

    useEffect(() => {
        const imageArr = [];
        if (image && image !== 'null') imageArr.push(image);
        if (secondImage && secondImage !== 'null') imageArr.push(`${process.env.GATSBY_URL}/${secondImage}`);
        if (thirdImage && thirdImage !== 'null') imageArr.push(`${process.env.GATSBY_URL}/${thirdImage}`);
        if (fourthImage && fourthImage !== 'null') imageArr.push(`${process.env.GATSBY_URL}/${fourthImage}`);
        if (fifthImage && fifthImage !== 'null') imageArr.push(`${process.env.GATSBY_URL}/${fifthImage}`);
        setImages(imageArr);
    }, [image, secondImage, thirdImage, fourthImage, fifthImage]);

    // accesories don't have same path to product category, so this function retrieves the correct name
    const productName = () => (
        <span className="details__name-no_break">{product?.name}</span>
    );

    const [thumbs, setThumbs] = useState();

    useEffect(() => {
        if (images.length <= 1) {
            setThumbs();
        }
    }, [images]);

    const selectBenefits = () => {
        if ((product?.lines?.benefits?.length && product?.benefits?.length) || product?.benefits?.length) {
            return product?.benefits?.filter((benefit) => benefit?.content !== '').map((advantage) => ({ desc: advantage.content }));
        }
        return product?.lines?.benefits?.length
            ? product?.lines?.benefits?.filter((benefit) => benefit?.content !== '').map((advantage) => ({ desc: advantage.content }))
            : [];
    };
    const benefits = selectBenefits();

    const currentPresentedVariant = variants?.filter((variant) => variant?.color?.alternative_id === properties?.color.id)[0];
    const replaceButton = !isDesktop && product?.price_type === 1 && currentPresentedVariant && currentPresentedVariant?.presentation_model_price;
    const priceView = (price) => {
        const priceLength = price?.toString().length;
        if (!price) {
            return null;
        }
        if (priceLength < 3) {
            return price;
        }
        return (
            <>
                {price?.toString().slice(0, priceLength - 3)}
                {' '}
                {price?.toString().slice(priceLength - 3)}
            </>
        );
    };
    return (
        <section className="details">
            <div className="details__inner-wrapper">
                <div className="details__images">
                    <div
                        className={ classnames(
                            'inner-wrapper__bestseller-favorite',
                            { 'inner-wrapper__bestseller-favorite--with-thumbs': images.length > 1 },
                            { 'inner-wrapper__bestseller-favorite--fav-only': !product.bestseller }
                        ) }
                    >
                        {Boolean(product.bestseller) && (
                            <span className={ classnames('bestseller-favorite__bestseller') }>bestseller</span>
                        )}
                        <button
                            type="button"
                            onClick={ (e) => {
                                e.preventDefault();
                                setFavorite();
                            } }
                            className={ classnames('bestseller-favorite-btn') }
                        >
                            <FontAwesomeIcon
                                className="favorite-icon"
                                style={{ color: COLOR_VIRIDIAN_GREEN }}
                                icon={ isFavorite() ? fasFaHeart : farFaHeart }
                            />
                        </button>
                    </div>
                    {images.length > 1 ? (
                        <>
                            <Swiper
                                style={{ order: 1, width: '100%' }}
                                thumbs={{ swiper: thumbs }}
                                onSwiper={ (swiper) => {
                                    swiper.update();
                                } }
                                onSlideChange={ (swiper) => setSliderIndex(swiper.realIndex) }
                                slidesPerView="auto"
                                navigation={{
                                    nextEl: '.productImagesCarousel--next',
                                    prevEl: '.productImagesCarousel--previous'
                                }}
                            >
                                {images?.map((currentValue, index) => (
                                    <SwiperSlide key={ index }>
                                        <Img className="details__image" src={ currentValue } alt={ product?.name } />
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                            <Swiper
                                className="details__thumbs"
                                slidesPerView="auto"
                                spaceBetween={ 10 }
                                direction="vertical"
                                onSwiper={ setThumbs }
                            >
                                {images?.map((currentValue, index) => (
                                    <SwiperSlide className="details__thumb" key={ index }>
                                        <Img className="thumb__image" src={ currentValue } alt={ product?.name } />
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                            <ButtonsView name="productImagesCarousel" />
                        </>
                    ) : (
                        <Img className="details__image" src={ images[0] } alt={ product?.name } />
                    )}
                </div>
            </div>
            <div className="details__container">
                {product?.lines
                    ? (
                        <>
                            <div className="details__wrapper">
                                <div>
                                    <h1 className="details__name">{productName()}</h1>
                                    <p className="details__line">
                                        Linia
                                        { ' ' }
                                        {product?.lines?.name}
                                    </p>
                                    <p
                                        className={ classnames('details__type', {
                                            'details__type--margin-bottom': !benefits?.length
                                        }) }
                                    >
                                        {product?.lines?.brands?.type}
                                    </p>
                                    {benefits.length ? (
                                        <div className="details__wrapper--desktop">
                                            <Property headline="Zalety" isDetailsWrapper>
                                                <ListView data={ benefits } />
                                            </Property>
                                        </div>
                                    ) : null}
                                </div>
                                <div className="details__buy" style={{ marginBottom: replaceButton && '28px' }}>
                                    {!replaceButton && <ButtonView text="Gdzie kupić?" link="/gdzie-kupic" />}
                                    <div className="details__price">
                                        <Img className="details__coins" src={ coins } alt="monety" />
                                        <p>
                                            {product?.price_type === 1 ? (
                                                <>
                                                    <p>
                                                        <strong className="details__price-container">
                                                            <p className="price">
                                                                od
                                                                { ' ' }
                                                                {priceView(product?.price)}
                                                            </p>
                                                            <p className="currency">zł netto</p>
                                                        </strong>
                                                        model standardowy
                                                    </p>
                                                    {product?.price_type === 1 && currentPresentedVariant && currentPresentedVariant?.presentation_model_price && (
                                                        <p className="details_price_extra">
                                                            <strong className="details__price-container">
                                                                <p className="price">
                                                                    od
                                                                    { ' ' }
                                                                    {priceView(currentPresentedVariant?.presentation_model_price)}
                                                                </p>
                                                                <p className="currency">zł netto</p>
                                                            </strong>
                                                            model prezentowany
                                                        </p>
                                                    )}
                                                </>
                                            )
                                                : (
                                                    <>
                                                        <strong className="details__price-container">
                                                            <p className="price">
                                                                od
                                                                { ' ' }
                                                                {priceView(product?.price)}
                                                            </p>
                                                            <p className="currency">zł netto</p>
                                                        </strong>
                                                        {
                                                            // eslint-disable-next-line eqeqeq
                                                            product?.lines && product?.price_type == 2 && 'cena skrzydła standard'
                                                        }
                                                        {!product?.lines && 'cena'}
                                                    </>
                                                )}
                                        </p>
                                    </div>
                                </div>
                                <div className="details__actions">
                                    {isClient && (
                                        <a
                                            className="details__download"
                                            href={ images[sliderIndex] }
                                            download={ images[sliderIndex] }
                                            // eslint-disable-next-line react/jsx-no-target-blank
                                            target="_blank"
                                        >
                                            <Img className="details__icon" src={ downloadIcon } alt="pobierz" />
                                            <span>Pobierz zdjęcie</span>
                                        </a>
                                    )}
                                    <button
                                        className="gallery-modal__share details__share-button"
                                        type="button"
                                        onClick={ () => setVisibility(true) }
                                    >
                                        <Img className="details__icon" src={ shareIcon } alt="udostępnij" />
                                        <span>Udostępnij</span>
                                    </button>
                                    {replaceButton && (
                                        <p style={{ marginTop: replaceButton && '14px' }}>
                                            <ButtonView text="Gdzie kupić?" link="/gdzie-kupic" />
                                        </p>
                                    )}
                                </div>
                            </div>

                        </>
                    )
                    : (
                        <div className="details__wrapper">
                            <div>
                                <h1 className="details__name">{productName()}</h1>
                                <p className="details__brand">
                                    Dla drzwi:
                                    {' '}
                                    <span>
                                        {product?.brands?.length && product?.brands[0]?.name?.split(' ')[1]}
                                        {' '}
                                        {product?.brands?.length && product?.brands[0]?.type?.split(' ')[1]}
                                    </span>
                                </p>
                            </div>
                            <div className="details__buy">
                                <ButtonView text="Gdzie kupić?" link="/gdzie-kupic" />
                                <div className="details__price">
                                    <Img className="details__coins" src={ coins } alt="monety" />
                                    <p>
                                        {product?.price_type === 1 ? (
                                            <strong className="details__price-container">
                                                <p className="price">
                                                    Model standardowy
                                                    <p>
                                                        { ' od ' }
                                                        {priceView(product?.price)}
                                                        { ' ' }
                                                        zł netto
                                                    </p>
                                                </p>
                                            </strong>
                                        )
                                            : (
                                                <>
                                                    <strong className="details__price-container">
                                                        <p className="price">
                                                            od
                                                            { ' ' }
                                                            {priceView(product?.price)}
                                                        </p>
                                                        <p className="currency">zł netto</p>
                                                    </strong>
                                                    {
                                                        // eslint-disable-next-line eqeqeq
                                                        product?.lines && product?.price_type == 2 && 'cena skrzydła standard'
                                                    }
                                                    {!product?.lines && 'cena'}
                                                </>
                                            )}

                                    </p>
                                </div>
                            </div>
                            <div className="details__actions">
                                {isClient && (
                                    <a
                                        className="details__download"
                                        href={ images[sliderIndex] }
                                        download={ images[sliderIndex] }
                                        // eslint-disable-next-line react/jsx-no-target-blank
                                        target="_blank"
                                    >
                                        <Img className="details__icon" src={ downloadIcon } alt="pobierz" />
                                        <span>Pobierz zdjęcie</span>
                                    </a>
                                )}
                                <button
                                    className="gallery-modal__share details__share-button"
                                    type="button"
                                    onClick={ () => setVisibility(true) }
                                >
                                    <Img className="details__icon" src={ shareIcon } alt="udostępnij" />
                                    <span>Udostępnij</span>
                                </button>
                            </div>
                        </div>
                    )}
                {children}
            </div>
            {isVisible && (
                <Modal
                    imageURI={ `${URL}/${getMainDoorImage(product) || product?.image}` }
                    onClose={ () => setVisibility(false) }
                />
            )}
        </section>
    );
};

DetailsView.propTypes = {
    product: PropTypes.instanceOf(Object).isRequired,
    properties: PropTypes.instanceOf(Object).isRequired,
    isVisible: PropTypes.bool.isRequired,
    isClient: PropTypes.bool.isRequired,
    children: PropTypes.node.isRequired,
    setVisibility: PropTypes.func.isRequired
};
